import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import AboutSection from "./components/AboutSection";
import ArticlePreview from "./components/ArticlePreview";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <CTASection />
        <AboutSection />
        <ArticlePreview />
      </main>
      <Footer />
    </>
  );
}